// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.err-field:not(.mob) {
  color: #03c;
}
.err-display-block {
  margin-top: 5px;
}
.err-display-line {
  font-size: 12px;
  margin: 0;
  line-height: 22px;
}
`, "",{"version":3,"sources":["webpack://./src/stores/cardstore/index.less"],"names":[],"mappings":"AAAA;EACE,WAAA;AACF;AACA;EACE,eAAA;AACF;AACA;EACE,eAAA;EACA,SAAA;EACA,iBAAA;AACF","sourcesContent":[".err-field:not(.mob) {\n  color: #03c;\n}\n.err-display-block{\n  margin-top: 5px;\n}\n.err-display-line{\n  font-size: 12px;\n  margin: 0;\n  line-height: 22px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
